/**
 * @generated SignedSource<<6d2ae5269ae2695b400dba5dc9770afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type connectApps_softwareReleasesVersionDetail$data = {
  readonly connectAddonIframeData: ReadonlyArray<{
    readonly appKey: string;
    readonly appName: string;
    readonly location: string;
    readonly moduleKey: string;
    readonly options: AGG$JSON | null | undefined;
  } | null | undefined>;
  readonly " $fragmentType": "connectApps_softwareReleasesVersionDetail";
};
export type connectApps_softwareReleasesVersionDetail$key = {
  readonly " $data"?: connectApps_softwareReleasesVersionDetail$data;
  readonly " $fragmentSpreads": FragmentRefs<"connectApps_softwareReleasesVersionDetail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "connectApps_softwareReleasesVersionDetail",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersionConnectAddonIframeData",
        "kind": "LinkedField",
        "name": "connectAddonIframeData",
        "plural": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "appKey"
            },
            "action": "THROW",
            "path": "connectAddonIframeData.appKey"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "moduleKey"
            },
            "action": "THROW",
            "path": "connectAddonIframeData.moduleKey"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "appName"
            },
            "action": "THROW",
            "path": "connectAddonIframeData.appName"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "location"
            },
            "action": "THROW",
            "path": "connectAddonIframeData.location"
          },
          {
            "kind": "ScalarField",
            "name": "options"
          }
        ]
      },
      "action": "THROW",
      "path": "connectAddonIframeData"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "5b5aa6740e6a7342f336e876f3dce998";

export default node;
